import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Button } from '@/components/ui/button';
    import { Minus } from 'lucide-vue-next';

export default /*@__PURE__*/_defineComponent({
  __name: 'DeactivateButton',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    variant: "ghost_destructive",
    size: "xs"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('forms.deactivate')), 1),
      _createVNode(_unref(Minus), { class: "text-destructive" })
    ]),
    _: 1
  }))
}
}

})